/* eslint-disable indent */
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueCookie from 'vue-cookie'
import money from 'v-money'
import VueNumerals from 'vue-numerals'
import EventBus from '@/plugins/EventBus.js'
import MomentVue from 'vue-moment'

Vue.use(MomentVue);
Vue.use(EventBus);
Vue.prototype.$bus = new Vue();
Vue.use(VueCookie)
Vue.use(money, {precision: 4})

Vue.use(VueNumerals, {
  locale: 'es',
  delimiters: {
        thousands: '',
        decimal: ','
      },
  currency: {
        symbol: '$'
    }
}
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js